import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  selectAll(event) {
    event.preventDefault();
    this.participantCheckboxes.forEach((checkbox) => {
      checkbox.checked = true;
    });
  }

  clearAll(event) {
    event.preventDefault();
    this.participantCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }

  print(event) {
    event.preventDefault();
    window.print();
  }

  get participantCheckboxes() {
    return Array.from(this.element.querySelectorAll(".participant-checkbox"));
  }
}
